import { cn } from '@/client/lib/utils';
import { InitialsAvatar } from '@/client/components/common/InitialsAvatar';
import type { RouterOutputs } from '@/client/utils/trpc';

type Employee = RouterOutputs['employees']['list'][number];

interface PersonRowProps {
  person: Employee;
  isSelected: boolean;
  onClick: () => void;
}

export function PersonRow({ person, isSelected, onClick }: PersonRowProps) {
  const displayName = person.full_name ?? person.email;
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={displayName}
      className={cn(
        'flex w-full items-center gap-3 border-b px-4 py-3 text-left transition-colors',
        'hover:bg-muted/50',
        isSelected ? 'border-l-2 border-l-primary bg-muted' : 'border-l-2 border-l-transparent',
      )}
    >
      <InitialsAvatar name={displayName} size={36} />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <span className="truncate text-sm font-medium">{displayName}</span>
        </div>
        <p className="truncate text-xs text-muted-foreground">{person.job_title ?? '—'}</p>
      </div>
      <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-good" />
    </button>
  );
}
